
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import Behavior from '~/components/Device/Behavior.vue';
import CHeader from '~/components/Device/ExpandingItems/Header.vue';
import HeatingAlgo from '~/components/Device/HeatingAlgo/index.vue';
import Offset from '~/components/Device/Offset.vue';
import SwitchDebugMode from '~/components/Device/SwitchDebugMode.vue';
import SensitivityConfig from '~/components/Device/Threshold/SensitivityConfig.vue';
import VisionRecognitionConfig from '~/components/Device/Threshold/VisionRecognitionConfig.vue';
import Owners from '~/components/Home/Owners.vue';
import LinkedUser from '~/components/LinkedUser.vue';
import { Device } from '~/interfaces/device.interface';
import UserRightsMixin from '~/mixins/UserRightsMixin';
import { DevicesModule } from '~/store/modules/devices';
import { OwnerModule } from '~/store/modules/owners';

@Component({
    components: {
        Behavior,
        Offset,
        HeatingAlgo,
        SwitchDebugMode,
        LinkedUser,
        CHeader,
        Owners,
        SensitivityConfig,
        VisionRecognitionConfig,
    },
})
export default class ExpandingItems extends Mixins(UserRightsMixin) {
    @Prop() device!: Device;

    openedPanels: number[] = [];

    get currentGateway() {
        return DevicesModule.currentGateway;
    }

    get offset() {
        return this.device?.offset;
    }

    get heatingAlgo() {
        return this.device?.heating_algo;
    }

    get showSwitchDebugMode() {
        return this.device?.hasSwitchDebugMode && this.isAllowed(this.currentGateway?.type || '', 'switchDebug');
    }

    get showBehavior() {
        return this.device?.behaviorFields && this.device.behaviorFields.length > 0;
    }

    get showFriendUsers() {
        return this.device?.friendUsers && this.device.friendUsers.length > 0;
    }

    get showSensitivityConfig() {
        return this.device?.hasSensitivityConfig && this.isAllowed(this.currentGateway?.type || '', 'getThresholds');
    }

    get showVisionRecognitionConfig() {
        return this.device?.hasVisionRecognitionConfig && this.isAllowed(this.currentGateway?.type || '', 'getThresholds');
    }

    get showOwners() {
        return !OwnerModule.homeId
            && OwnerModule.owners.length > 0
            && this.device.id === this.currentGateway?.id
            && !this.device?.homeId;
    }

    @Watch('device')
    onDeviceChange() {
        this.openedPanels = [];
    }
}
